import { REGISTER_USER, REGISTER_USER_SUCCESSFUL, REGISTER_USER_FAILED } from './actionTypes';
import {message} from "antd";

const initialState = {
    registrationError: null, message: null, loading: false, user: undefined, error: false
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_USER:
            state = {
                ...state,
                user: null,
                loading: true,
                error: false,
                message: null,
                registrationError: null
            }
            break;
        case REGISTER_USER_SUCCESSFUL:
            state = {
                ...state,
                loading: false,
                registrationError: null
            }
            break;
        case REGISTER_USER_FAILED:
            state = {
                ...state,
                error: true,
                loading: false
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default account;